import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateCallResultModal({ isOpen, toggle, refreshSettings, resultToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [resultData, setResultData] = useState({
    name: resultToEdit?.name || null,
    color: resultToEdit?.color || '#000000',
  });

  useEffect(() => {
    if(resultToEdit) {
      setResultData({
        name: resultToEdit?.name || null,
        color: resultToEdit?.color || '#000000',
      });
    } else {
      setResultData({
        name: null,
      });
    }
  }, [resultToEdit, isOpen]);

  const saveCallResult = async () => {
    setSaveLoading(true);
    const url = resultToEdit ? `/crm/settings/call-results/update/${resultToEdit.id}` : '/crm/settings/call-results/store';
    const data = await post(url, resultData);
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(resultToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{resultToEdit ? t('crm.settings.call_results.edit') : t('crm.settings.call_results.create_new')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={resultData?.name}
            onChange={e => setResultData({...resultData, name: e.target.value})}
          />
        </FormGroup>
        <div>
          <Label>{ t('common.color') }: </Label>
          <input 
            type="color"
            value={resultData?.color || '#000000'}
            onChange={e => setResultData({...resultData, color: e.target.value})}
            className="form-control form-control-color"
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveCallResult}
          loading={saveLoading}
          disabled={saveLoading || !resultData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateCallResultModal;